import _ from '@/common/helpers';
import FILTER_TYPES from '@/components/query/filter-types';
import FILTER_SOURCE_TYPES from '@/components/query/filter-source-type';

/* eslint-disable quote-props */
export default {
    id: 'orders',
    version: 2,
    filterSpec: {
        id: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'subscriptions',
                labelBuilder: ({id}) => `${_.truncate(id, {limit: 11, dots: true})}`,
                value: 'id',
            },
        },
        customerId: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'customers',
                labelBuilder: ({id}) => `${_.truncate(id, {limit: 11, dots: true})}`,
                value: 'id',
            },
        },
        websiteId: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'websites',
                labelBuilder: ({id, name}) => `${_.truncate(id, {limit: 11, dots: true})}-${name}`,
                value: 'id',
            },
        },
        orderType: {
            label: 'Type',
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.definitions,
                path: 'Subscription/orderType/enum',
            },
        },
        startTime: {
            type: FILTER_TYPES.datetime,
        },
        renewalTime: {
            type: FILTER_TYPES.datetime,
        },
        canceledTime: {
            type: FILTER_TYPES.datetime,
        },
        'deliveryAddress.firstName': {
            type: FILTER_TYPES.text,
        },
        'deliveryAddress.lastName': {
            type: FILTER_TYPES.text,
        },
        'deliveryAddress.organization': {
            type: FILTER_TYPES.text,
        },
        'deliveryAddress.address': {
            type: FILTER_TYPES.text,
        },
        'deliveryAddress.address2': {
            type: FILTER_TYPES.text,
        },
        'deliveryAddress.city': {
            type: FILTER_TYPES.text,
        },
        'deliveryAddress.region': {
            type: FILTER_TYPES.text,
        },
        'deliveryAddress.country': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.countries,
            },
        },
        'deliveryAddress.postalCode': {
            type: FILTER_TYPES.text,
        },
        // Todo delivery names & emails
        'billingAddress.firstName': {
            type: FILTER_TYPES.text,
        },
        'billingAddress.lastName': {
            type: FILTER_TYPES.text,
        },
        'billingAddress.organization': {
            type: FILTER_TYPES.text,
        },
        'billingAddress.address': {
            type: FILTER_TYPES.text,
        },
        'billingAddress.address2': {
            type: FILTER_TYPES.text,
        },
        'billingAddress.city': {
            type: FILTER_TYPES.text,
        },
        'billingAddress.region': {
            type: FILTER_TYPES.text,
        },
        'billingAddress.country': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.countries,
            },
        },
        'billingAddress.postalCode': {
            type: FILTER_TYPES.text,
        },
        // Todo delivery names & emails
        'riskMetadata.ipAddress': {
            type: FILTER_TYPES.text,
        },
        'riskMetadata.isProxy': {
            type: FILTER_TYPES.boolean,
        },
        'riskMetadata.isTor': {
            type: FILTER_TYPES.boolean,
        },
        'riskMetadata.isVpn': {
            type: FILTER_TYPES.boolean,
        },
        'riskMetadata.isHosting': {
            type: FILTER_TYPES.boolean,
        },
        'riskMetadata.vpnServiceName': {
            type: FILTER_TYPES.text,
        },
        'riskMetadata.isp': {
            type: FILTER_TYPES.text,
        },
        'riskMetadata.country': {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.countries,
            },
        },
        'riskMetadata.latitude': {
            type: FILTER_TYPES.text,
        },
        'riskMetadata.longitude': {
            type: FILTER_TYPES.text,
        },
        'riskMetadata.postalCode': {
            type: FILTER_TYPES.text,
        },
        'riskMetadata.timeZone': {
            type: FILTER_TYPES.text,
        },
        'riskMetadata.accuracyRadius': {
            type: FILTER_TYPES.text,
        },
        'riskMetadata.fingerprint': {
            type: FILTER_TYPES.text,
        },
        'riskMetadata.httpHeaders': {
            type: FILTER_TYPES.text,
        },
        'riskMetadata.distance': {
            type: FILTER_TYPES.text,
        },
        'riskMetadata.score': {
            type: FILTER_TYPES.text,
        },
        initialInvoiceId: {
            type: FILTER_TYPES.text,
        },
        status: {
            type: FILTER_TYPES.select,
            options: {
                // TODO one-time-order/status/enum + subscription-order/status/enum
                source: FILTER_SOURCE_TYPES.enum,
                enum: [
                    'pending',
                    // 'paid',
                    'active',
                    'canceled',
                    'churned',
                    'suspended',
                    'paused',
                    'abandoned',
                ],
            },
        },
        // status: {
        //     type: FILTER_TYPES.select,
        //     options: {
        //         source: FILTER_SOURCE_TYPES.definitions,
        //         path: 'Subscription/status/enum',
        //     },
        // },
        autopay: {
            type: FILTER_TYPES.boolean,
        },
        inTrial: {
            type: FILTER_TYPES.boolean,
        },
        rebillNumber: {
            type: FILTER_TYPES.text,
        },
        canceledBy: {
            type: FILTER_TYPES.text,
        },
        cancelDescription: {
            type: FILTER_TYPES.text,
        },
        activationTime: {
            type: FILTER_TYPES.datetime,
        },
        endTime: {
            type: FILTER_TYPES.datetime,
        },
        createdTime: {
            type: FILTER_TYPES.datetime,
        },
        updatedTime: {
            type: FILTER_TYPES.datetime,
        },
    },
};
